import { render } from "./IconMediaflowEmptyPlaceholderImage.vue?vue&type=template&id=20488c92"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMediaflowEmptyPlaceholderImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20488c92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20488c92', __exports__)) {
    api.reload('20488c92', __exports__)
  }
  
  module.hot.accept("./IconMediaflowEmptyPlaceholderImage.vue?vue&type=template&id=20488c92", () => {
    api.rerender('20488c92', render)
  })

}


export default __exports__